import { Component, Input } from '@angular/core';
import { BAND_MAP, bandOf } from '../risk-register.util';

/** 28px band-tinted score pill (spec §3.5); an optional trend arrow sits inside it. */
@Component({
  selector: 'app-risk-score-chip',
  template: `<span class="score-chip" [ngClass]="[map.bgColor, map.textColor]" [attr.data-testid]="'score-chip-' + score">{{ score }}@if (trend === 'up' || trend === 'down') {<span class="trend" data-testid="score-chip-trend">{{ trend === 'up' ? '▲' : '▼' }}</span>}</span>`,
  styles: [`
    .score-chip { display: inline-flex; align-items: center; justify-content: center; min-width: 40px; height: 28px; border-radius: 14px; font: 700 14px/28px 'Montserrat'; padding: 0 8px; }
    .trend { margin-left: 6px; font: 600 12px/28px 'Montserrat'; }
    .bg-low { background: #36AB1933; } .txt-low { color: #186F03; }
    .bg-medium { background: #F7B50033; } .txt-medium { color: #8A6500; }
    .bg-high { background: #FF6B0033; } .txt-high { color: #CC5500; }
    .bg-critical { background: #E0202033; } .txt-critical { color: #E02020; }
  `],
  standalone: false,
})
export class RiskScoreChipComponent {
  @Input() score = 0;
  @Input() trend?: 'up' | 'down' | 'same';
  get map() { return BAND_MAP[bandOf(this.score)]; }
}
